/** @jsx jsx */
import React from "react";
import { connectHits, Highlight } from "react-instantsearch-dom";
import { Row, Col, Card, Typography, Skeleton } from "antd";
import {
    jsx,
    Flex,
    Avatar,
    Button,
    Text,
    Image,
    Link,
    Box,
} from "theme-ui";

import ContribStatus from "./contribStatus";
import Icon from "../Icon";
import GithubIcon from "../../../img/avatars/github.png";
import defaultIcon from '../../../images/favicon.png';
import Action from '../Action';

const { Paragraph } = Typography;

let SITE_URL = "";
if (typeof window !== 'undefined') {
    SITE_URL = window.location.hostname;
}

const Hits = ({ hits, mobileView, path }) => (
    <Flex
        sx={{
            flexDirection: "column",
            padding: "16px",
            backgroundColor: "#FAFAFA",
        }}
    >
        {hits.map((hit) => (
                
                <Card
                    sx={{
                        backgroundColor: "#FFFFFF",
                        marginBottom: "16px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "8px",
                    }}
                    key={hit.description}
                    bordered={false}>
                        <Flex
                            sx={{
                                justifyContent: 'space-between', flexDirection: ['column', 'row'], marginBottom: "8px"
                            }}
                        >
                            <Box>
                                {hit?.icon ?
                                    <Image
                                        src={hit.icon}
                                        sx={{
                                            height: "32px",
                                            width: "auto",
                                            marginRight: "16px",
                                        }}
                                        alt="icon"
                                    />
                                    : <Image
                                        src={defaultIcon}
                                        sx={{
                                            height: "32px",
                                            width: "auto",
                                            marginRight: "16px",
                                        }}
                                        alt="default icon" />}
                                <Link href={`${path}/packages/${hit.package_name.toLowerCase().split(' ').join('_')}`}>
                                    <strong className="expec-labels">
                                        <Highlight attribute="package_name" hit={hit} tagName="strong" />&nbsp;&nbsp;
                                    </strong>
                                </Link>
                                {/* {!mobileView &&
                                    <Text>{hit.expectation_count} Total</Text>
                                } */}
                            </Box>
                            <Box sx={{ textAlign: ['right'] }}>


                                {!mobileView &&
                                    <Link
                                        href={`${path}/packages/${hit.package_name.toLowerCase().split(' ').join('_')}`}
                                        sx={{ marginLeft: "auto" }}
                                    >
                                        <Button
                                            ml="auto"
                                            sx={{
                                                borderRadius: "4px",
                                                border: "1px solid #D9D9D9",
                                                backgroundColor: "orangeV2",
                                                color: "#FFFFFF",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                                padding: "4px 16px",
                                            }}
                                        >
                                            See more
                                        </Button>
                                    </Link>}
                            </Box>
                        </Flex>
                        {mobileView &&
                            <Box sx={{ mt: "4%", ml: "12%" }}>
                                <Text>{hit.expectation_count} Total</Text>
                            </Box>}
                    <Row
                        sx={{
                            fontSize: "14px",
                            marginBottom: "8px",
                        }}
                    >
                        <Paragraph className="mobile_card" >
                            <Highlight attribute="description" hit={hit} tagName="strong" />
                        </Paragraph>
                    </Row>

                    <Row sx={{ marginBottom: "16px", fontSize: "12px" }}>
                        {/* Comment code owners */}
                        {!mobileView &&
                            <Col span={12}>
                                <Flex sx={{ flexDirection: "column" }}>
                                    <strong className="expec-labels">Code Owners: </strong>
                                    <Flex sx={{ marginTop: "6px", gap: "8px" }}>
                                        {hit.owners ?
                                            hit.owners.map((owner) => (
                                                <Link
                                                    key={owner.username}
                                                    target="_blank"
                                                    href={`https://github.com/${owner.username}`}
                                                    rel="noreferrer"
                                                >
                                                    <Avatar
                                                        src={`https://github.com/${owner.username}.png`}
                                                        size="24"
                                                        shape="circle"
                                                        backgroundColor="white"
                                                    />
                                                </Link>
                                            )) : <Text sx={{ fontWeight: "500" }}>None</Text>}
                                    </Flex>
                                </Flex>
                            </Col>
                        }
                        <Col span={12}>
                            <Flex sx={{ flexDirection: "column" }}>
                                <strong className="expec-labels">Domain expert: </strong>
                                <Flex sx={{ marginTop: "6px", gap: "8px" }}>
                                    {hit.domain_experts ?
                                        hit.domain_experts.map((expert) => (
                                            <Link
                                                key={expert.full_name}
                                                target="_blank"
                                                href={expert.social_links}
                                                rel="noreferrer"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    '@media screen and (max-width: 575px)': {
                                                        flexDirection: 'column'
                                                    }
                                                }}

                                            >
                                                <Avatar
                                                    src={expert.picture}
                                                    size="24"
                                                    shape="circle"
                                                    backgroundColor="white"
                                                />
                                                <Text
                                                    sx={{
                                                        color: "#262626",
                                                        fontWeight: 600,
                                                        marginLeft: "8px",
                                                    }}
                                                >
                                                    {expert.full_name}
                                                </Text>
                                            </Link>
                                        )) : <Text sx={{ fontWeight: "500" }}>None</Text>}
                                </Flex>
                            </Flex>
                        </Col>
                    </Row>

                    <Row sx={{ marginBottom: "16px", fontSize: "12px" }}>
                        <Flex sx={{ flexDirection: "column" }}>
                            <strong className="expec-labels">Contributors: </strong>
                            <Flex sx={{ marginTop: "6px", gap: "8px" }}>
                                {hit.contributors && hit.contributors.length > 0 ?
                                    hit.contributors.map((contributor) => (
                                        <Link
                                            key={contributor.username}
                                            target="_blank"
                                            href={`https://github.com/${contributor.username === "@great_expectations" ? "great-expectations" : contributor.username.substring(1)}`}
                                            rel="noreferrer"
                                        >
                                            <Avatar
                                                src={
                                                    `https://github.com/${contributor.username === "@great_expectations" ? "great-expectations" : contributor.username.substring(1)}.png`
                                                }
                                                onError={({ currentTarget }) => {
                                                    const currentElement = currentTarget;
                                                    currentElement.onerror = null;
                                                    currentElement.src = GithubIcon;
                                                }}
                                                size="24"
                                                shape="circle"
                                                backgroundColor="white"
                                            />
                                        </Link>
                                    )) : <Text sx={{ fontWeight: "500" }}>None</Text>}
                            </Flex>
                        </Flex>
                    </Row>

                    {!mobileView &&
                        <Box sx={{ marginBottom: "16px", fontSize: "12px" }}>
                            <Flex sx={{ alignItems: ['flex-start'], flexDirection: ['column', null, null, 'row'] }} className="card-view-dependencies">
                                <Box sx={{minWidth:'130px'}}>
                                    <strong className="expec-labels">
                                        Dependencies: &nbsp;&nbsp;{" "}
                                    </strong>
                                </Box>
                                <Flex
                                    sx={{
                                        marginLeft: "16px",
                                        gap: "8px",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {hit.dependencies.length > 0
                                        ? hit.dependencies.map((value) => (
                                            <React.Fragment key={value.link}>
                                                <Link
                                                    href={value.link}
                                                    sx={{
                                                        display: "Flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                    }}
                                                >
                                                    <Icon
                                                        icon="external-link"
                                                        fontSize="14px"
                                                        sx={{ color: "#7470EB", ml: "8px" }}
                                                    />
                                                    <span
                                                        sx={{ fontSize: "14px", color: "#7470EB" }}
                                                    >
                                                        {value.text}
                                                    </span>
                                                </Link>
                                            </React.Fragment>
                                        )
                                        )
                                        : <Text sx={{ fontWeight: "500" }}>None</Text>}
                                </Flex>
                            </Flex>
                        </Box>}

                    {!mobileView &&
                        <Box>

                            <Flex sx={{ fontSize: "12px" }}>
                                <Box sx={{ marginBottom: "8px" }}>
                                    <Link
                                        href={`${path}/expectations/?filterType=Package&viewType=Summary&showFilters=true&subFilterValues=${hit.package_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().split(' ').join('_')}`}
                                        sx={{ marginLeft: "auto" }}>
                                        <strong className="expec-labels" sx={{ marginBottom: "8px" }}>
                                            {hit.package_name + "Expectations: "}
                                        </strong>
                                        <br></br>
                                        <br></br>
                                        {`https://${SITE_URL}${path}/expectations/?filterType=Package&viewType=Summary&showFilters=true&subFilterValues=${hit.package_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().split(' ').join('_')}`}
                                    </Link>
                                </Box>
                            </Flex>
                            {/* <Flex sx={{ flexDirection: ['column', 'row'], justifyContent: 'space-between' }}>
                                <ContribStatus
                                    data={hit}
                                    data1={hit}
                                    contribType="Experimental"
                                    className="red"
                                />
                                <ContribStatus
                                    data={hit}
                                    data1={hit}
                                    contribType="Beta"
                                    className="orange"
                                />
                                <ContribStatus
                                    data={hit}
                                    data1={hit}
                                    contribType="Production"
                                    className="green"
                                />

                            </Flex> */}
                        </Box>
                    }

                    {mobileView &&
                        <Row>
                            <Col span={24}>
                                <Link
                                    ml="auto"
                                    href={`${path}/packages/${hit.package_name.toLowerCase().split(' ').join('_')}`}
                                    sx={{
                                        width: "100%",
                                        borderRadius: "4px",
                                        border: "1px solid #D9D9D9",
                                        backgroundColor: "orangeV2",
                                        color: "#FFFFFF",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        padding: "4px 16px",
                                        textAlign: "center",
                                        display: "inline-block",
                                    }}>
                                    See More
                                </Link>
                            </Col>
                        </Row>}
                </Card>
        ))}
        {hits.length === 0 && <Flex sx={{ alignItems:'center', justifyContent:'center',}}>
        <Box sx={{minWidth:['270px', 'max-content']}}>
        <Action
        label="Can't find the Expectation you need? Create an Expectation."
        url="https://docs.greatexpectations.io/docs/guides/expectations/creating_custom_expectations/overview/"
        style="secondaryV2"
        fontsize="14px"
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }} />
        </Box>
        </Flex>}
    </Flex>
);

const CustomHits = connectHits(Hits);



class CardView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,

        };
    }

    componentDidMount() {

        this.setState({
            isLoaded: true,
        });
    }

    render() {
        const {
            isLoaded,
            screenSize
        } = this.state;
        if (!isLoaded) {
            return (
                <Row sx={{ marginTop: "32px" }}>
                    <Skeleton paragraph={{ rows: 4 }} />
                </Row>
            );
        }
        const path = this.props.version?`/legacy/${this.props.version}`:'';
        return (
            <CustomHits mobileView={screenSize} path={path}/>
        );
    }
}

export default CardView;
